import { useMemo } from 'react'
import type { AiChatPageContext, AiChatPeriodContext } from '@ztechapps/common.contract'
import { useUserTimeZone } from '@ztechapps/common.hook'
import { useOpenPivotContext } from '@ztechapps/webui.reporting'

export type UseChatPageContextResult = AiChatPageContext

/**
 * Page state the chat carries on each request: the user's time zone, the report pages, the open pivot (when a
 * pivot page is mounted) and, when the app has one, the working period.
 */
export const useChatPageContext = ({ period }: { period?: AiChatPeriodContext } = {}): UseChatPageContextResult => {
  const { openPivot, reportPages } = useOpenPivotContext()
  const timeZone = useUserTimeZone()

  return useMemo(
    () => ({
      timeZone,
      reportPages,
      pivot: openPivot
        ? {
            report: openPivot.report,
            fields: openPivot.fields,
            layout: openPivot.layout,
            loadedDays: openPivot.loadedDays,
            headerFilters: openPivot.headerFilters,
          }
        : undefined,
      period,
    }),
    [timeZone, reportPages, openPivot, period]
  )
}
